import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParsedUrlQuery } from "querystring";
import getChannelConfigByPathName from "src/api/channel";
import PrivacyPolicy from "src/components/icth-product/privacy/PrivacyPolicy";
import { withLayout } from "src/components/Layout/withLayout";
import { LOGICAL_GROUP_CHANNEL_CODE } from "src/constants/logicalGroupChannelCode";

interface PrivacyPageParams extends ParsedUrlQuery {
  channelPath: string;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<PrivacyPageParams>
) {
  const channelPath = context.params?.channelPath;
  const locale = context.locale || "en";
  const channelConfig = await getChannelConfigByPathName(channelPath);

  if (
    !channelConfig ||
    channelConfig.logicalGroupChannelCode !== LOGICAL_GROUP_CHANNEL_CODE
  ) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      channelPath,
      channelConfig,
      isShowAnnouncement: false,
      title: "Privacy Policy",
      ...(await serverSideTranslations(locale, [
        "common",
        "cookie-consent",
        "layout",
        "privacy",
      ])),
    },
  };
}

export default withLayout(PrivacyPolicy);
